import { prettify, renderEUDate } from "../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

const columns = [
  {
    size: 100,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: false,
    filterFn: "contains",
    accessorFn: (row) =>
      row.patient_info === undefined ? "" : `${row.patient_info}`, // per ora
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Paziente",
  },
  {
    size: 100,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: false,
    filterFn: "contains",
    accessorFn: (row) =>
      row.doctor_info === undefined ? "" : `${row.doctor_info}`,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    id: "professionista_sanitario",
    header: "Professionista Sanitario",
  },
  {
    size: 80,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: false,
    filterFn: "contains",
    accessorFn: (row) => prettify(row.service),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Tipo",
  },
  {
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    size: 80,
    accessorFn: (row) => renderEUDate(row.start_date),
    accessorKey: "start_date",
    enableColumnFilter: true,
    header: "Data di Inizio",
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
  },
  {
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    size: 80,
    accessorFn: (row) => renderEUDate(row.end_date),
    enableColumnFilter: true,
    header: "Data di Fine",
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
  },
  {
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    size: 120,
    enableColumnFilter: false,
    header: "Note",
    accessorFn: (row) => row.note,
  },
  {
    size: 25,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    accessorKey: "org_name",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Org",
    filterVariant: "select",
  },
];

export default columns;
